import * as React from "react";
const SvgFiRrLinkHorizontal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M3.771 13.38a1 1 0 0 1-1.407.134A6.48 6.48 0 0 1 .001 8.499 6.506 6.506 0 0 1 6.5 2h5C15.084 2 18 4.916 18 8.5S15.084 15 11.5 15a1 1 0 1 1 0-2c2.481 0 4.5-2.019 4.5-4.5S13.981 4 11.5 4h-5A4.505 4.505 0 0 0 2 8.5a4.49 4.49 0 0 0 1.637 3.472 1 1 0 0 1 .134 1.408m17.866-2.895a1 1 0 1 0-1.274 1.543A4.49 4.49 0 0 1 22 15.5c0 2.481-2.019 4.5-4.5 4.5h-5A4.506 4.506 0 0 1 8 15.5c0-2.481 2.019-4.5 4.5-4.5a1 1 0 1 0 0-2A6.51 6.51 0 0 0 6 15.5c0 3.584 2.916 6.5 6.5 6.5h5c3.584 0 6.5-2.916 6.5-6.5a6.49 6.49 0 0 0-2.363-5.015"
    />
  </svg>
);
export default SvgFiRrLinkHorizontal;
